import { useMemo, useRef, useState } from 'react';
import {
    Button,
    Grid,
} from '@mui/material';
import {  GeneralTable, SingleTableBoxScene } from '@/shared/components/ui';
import { MRT_ColumnDef } from 'material-react-table';
import { gridSizeMdLg12, gridSizeMdLg6, useCheckPermissions, useDownloadFile } from '@/shared';
import DateRangePicker from '@/shared/components/ui/CustomSearch/DateRangePicker';
import { usefetchReporteActividadInventarioUsuario } from '@/shared/actions/erp';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { RiFileExcel2Fill } from 'react-icons/ri';
import { PermissionsEnum } from '@/auth/interfaces';


export interface ActividadInventario {
    razon_social: string,
    cantidad_ingresos: number,
    cantidad_egresos: number,
    cantidad_traslados: number,
    cantidad_cuadres: number
}

export default function ReporteActividadInventarioPage() {
    useCheckPermissions(PermissionsEnum.reporte_actividad_inventario_usuario)
    
    const flatpickrRef = useRef<any>();
    const [dateRange, setDateRange] = useState<Date[]>([]);
    const [data, setData] = useState<ActividadInventario[]>([]);
    const {handleDownloadFile} = useDownloadFile()

    const onChangeRangeDate = (range:Date[]) => {
        if (!range[0] || !range[1]) {
            return;
        }
        setDateRange(range);
        loadReporte(dayjs(range[0]).format('YYYY-MM-DD'), dayjs(range[1]).format('YYYY-MM-DD'));
    };

    const { mutateAsync: fetchReporteActividadInventarioUsuario } = usefetchReporteActividadInventarioUsuario({});

    const columns = useMemo<MRT_ColumnDef<ActividadInventario>[]>(
        () => [
            {
                accessorKey: "razon_social",
                header: "Razón Social",
                size: 200,
                enableColumnFilter:true
            },
            {
                accessorKey: "cantidad_ingresos",
                header: "Cantidad de ingresos",
                size: 200,
            },
            {
                accessorKey: "cantidad_egresos",
                header: "Cantidad de egresos",
                size: 200,
            },
            {
                accessorKey: "cantidad_traslados",
                header: "Cantidad de traslados",
                size: 200,
            },
            {
                accessorKey: "cantidad_cuadres",
                header: "Cantidad de cuadres",
                size: 200,
            }
        ],
        []
    );

    const loadReporte = async(fecha_inicio:string, fecha_fin:string) => {
        console.log(fecha_inicio, fecha_fin);

        const data = await fetchReporteActividadInventarioUsuario({
            fecha_inicio: fecha_inicio,
            fecha_fin: fecha_fin,
        });
        setData(data?.data as any || []);
    };
    const descargarReporte = async(fecha_inicio:Date, fecha_fin:Date) => {
        const fechaInicio = dayjs(fecha_inicio).format('YYYY-MM-DD');
        const fechaFin = dayjs(fecha_fin).format('YYYY-MM-DD');
        if (!fechaInicio || !fechaFin) {
            return toast.error('Debe seleccionar un rango de fechas');
        }
        
        await handleDownloadFile({
            url:"api/v1/reporte-actividad-inventario-usuario/",
            method:"post",
            data:{
                fecha_inicio: fechaInicio,
                fecha_fin: fechaFin,
                habilitar_descarga: true
            },
            nameFile:`Reporte Actividad de Inventario ${dayjs().format("DD-MM-YYYY")} - ${dayjs(fechaInicio).format("DD-MM-YYYY")} al ${dayjs(fechaFin).format("DD-MM-YYYY")}`,
            extensionFile:"xlsx"
        })
    };

    return (
        <>
            <SingleTableBoxScene
            title="Reporte de Actividad de Inventario"
            >
                <Grid {...gridSizeMdLg12} container item spacing={2} paddingY={2}>
                    <Grid {...gridSizeMdLg6} container item>
                        <DateRangePicker
                            size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                            flatpickrRef={flatpickrRef}
                            onChange={(range) => onChangeRangeDate(range)}
                            label="Rango de fechas"
                            custom_options={{
                                maxDate: new Date(),
                            }}
                        />
                    </Grid>
                    <Grid {...gridSizeMdLg6} container item justifyContent={"end"} justifyItems={"flex-end"}>
                        <Button
                            variant="outlined"
                            color="success"
                            onClick={() => descargarReporte(dateRange[0], dateRange[1])}
                            startIcon={
                                <RiFileExcel2Fill />
                            }
                        >
                            {'Descargar Excel'}
                        </Button>
                    </Grid>
                </Grid>

                <GeneralTable<ActividadInventario>
                    columns={columns}
                    data={data || []}
                    pagination={1}
                    onPaging={undefined}
                    enableColumnActions={false}
                    enableEditing={false}
                    rowCount={data?.length||0}
                    enableGlobalFilter={false}
                    enableColumnFilters={true}
                    enablePagination={false}
                />
            </SingleTableBoxScene>

        </>
    );
}
